/* src/app/modules/ct-status/components/cts-gantry-functional-unit-step-list/cts-gantry-functional-unit-step-list.component.scss */
:host {
  display: flex;
  flex-flow: row nowrap;
  gap: 0.25rem;
  align-items: center;
}
/*# sourceMappingURL=cts-gantry-functional-unit-step-list.component.css.map */
